// These are the rules by which the form input fields will be checked against.

import { formHasErrors, formHasValue, setFormValues } from "./objectValidation";

/**
 * Criteria:
 * 1) Required
 */
const usernameValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "username", true, "Required");
    }

    return setFormValues(row, "username", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) Must be a valid email
 */
const emailValidation = (prevConfig, row, value) => {
    // 1)
    if (value.trim() === "") {
        return setFormValues(row, "email", true, "Required");
    }

    // 2)
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return setFormValues(row, "email", true, "Invalid email");
    }

    return setFormValues(row, "email", false, "");
};

/**
 * Criteria:
 * 1) Required
 * 2) At least 4 characters, matching the backend rule
 */
const passwordValidation = (prevConfig, row, value) => {
    // 1)
    if (!value || value.trim() === "") {
        return setFormValues(row, "password", true, "Required");
    }

    // 2)
    if (value.length < 4) {
        return setFormValues(row, "password", true, "Must be at least 4 characters");
    }

    return setFormValues(row, "password", false, "");
};

// The main constant, directing to the specific validation function.
export const USER_VALIDATION = {
    username: {
        check: usernameValidation
    },
    email: {
        check: emailValidation
    }
};

// Creating a user additionally requires an initial password.
export const USER_CREATE_VALIDATION = {
    ...USER_VALIDATION,
    password: {
        check: passwordValidation
    }
};

export const IS_USER_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "email");
};

export const IS_USER_CREATE_VALID = (obj) => {
    return !formHasErrors(obj) && formHasValue(obj, "username") && formHasValue(obj, "email") && formHasValue(obj, "password") && formHasValue(obj, "role_id");
};
